import { render } from "./getPrice.vue?vue&type=template&id=bbea45e4&scoped=true"
import script from "./getPrice.vue?vue&type=script&lang=js"
export * from "./getPrice.vue?vue&type=script&lang=js"

import "./getPrice.vue?vue&type=style&index=0&id=bbea45e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbea45e4"]])

export default __exports__